/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type MyMentorShiftsQueryVariables = Types.Exact<{
  event_id: Types.Scalars["Int"];
}>;

export type MyMentorShiftsQuery = {
  myMentorShifts: Array<
    Pick<
      Types.EventActivity,
      "id" | "name" | "start_time" | "end_time" | "location"
    >
  >;
};

export const MyMentorShiftsDocument = gql`
  query MyMentorShifts($event_id: Int!) {
    myMentorShifts(event_id: $event_id) {
      id
      name
      start_time
      end_time
      location
    }
  }
`;

/**
 * __useMyMentorShiftsQuery__
 *
 * To run a query within a React component, call `useMyMentorShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyMentorShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyMentorShiftsQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useMyMentorShiftsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MyMentorShiftsQuery,
    MyMentorShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    MyMentorShiftsQuery,
    MyMentorShiftsQueryVariables
  >(MyMentorShiftsDocument, baseOptions);
}
export function useMyMentorShiftsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MyMentorShiftsQuery,
    MyMentorShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    MyMentorShiftsQuery,
    MyMentorShiftsQueryVariables
  >(MyMentorShiftsDocument, baseOptions);
}
export type MyMentorShiftsQueryHookResult = ReturnType<
  typeof useMyMentorShiftsQuery
>;
export type MyMentorShiftsLazyQueryHookResult = ReturnType<
  typeof useMyMentorShiftsLazyQuery
>;
export type MyMentorShiftsQueryResult = ApolloReactCommon.QueryResult<
  MyMentorShiftsQuery,
  MyMentorShiftsQueryVariables
>;
